import * as React from 'react';
import { useRef, useState } from 'react';
import type { TextInput } from 'react-native';
import { useClickOutside } from 'react-native-click-outside';
import {
    BodyMediumRegular,
    Shadows,
    StyledBodyMediumRegularInput,
    XStack,
} from 'smoothie';

import type { PaycheckRoutingRule } from '../../../../../types/PaycheckRouting';

interface RemainingRuleAmountProps {
    rule: Partial<PaycheckRoutingRule>;
    onUpdate: (value: number) => void;
    disabled?: boolean;
}

const RemainingRuleAmount = ({
    rule,
    onUpdate,
    disabled,
}: RemainingRuleAmountProps) => {
    const [isEditing, setIsEditing] = useState(false);

    const inputRef = useRef<TextInput>(null);

    const wrapperRef = useClickOutside(() => {
        setIsEditing(false);
        inputRef.current?.blur();
    });

    return (
        <XStack
            ref={wrapperRef}
            borderWidth={1}
            borderColor="$gray200"
            borderRadius={12}
            alignItems="center"
            justifyContent="flex-end"
            overflow="hidden"
            padding={16}
            width={73}
            onPress={() => {
                if (disabled) return;
                setIsEditing(true);
                inputRef.current?.focus();
            }}
        >
            <StyledBodyMediumRegularInput
                ref={inputRef}
                keyboardType="number-pad"
                value={
                    !isEditing && (rule.amount ?? 0) === 0
                        ? '0'
                        : (rule.amount ?? '').toString()
                }
                onChangeText={(incomingValue) => {
                    onUpdate(
                        parseInt(
                            incomingValue === '' ? '0' : incomingValue,
                            10,
                        ),
                    );
                }}
                maxLength={3}
                height={22}
                width="auto"
                padding={0}
                style={{ ...Shadows.SMALL }}
                onPressIn={() => {
                    if (disabled) return;
                    setIsEditing(true);
                }}
                disabled={disabled}
                returnKeyType="done"
            />
            <BodyMediumRegular>%</BodyMediumRegular>
        </XStack>
    );
};

export default RemainingRuleAmount;
